import { IPublished } from 'source/NFR.types';

const Published: React.FC<IPublished> = ({ type, date }) => {
  if (!date) return null;
  return (
    <div className="published">
      <b>{`${type}:`}</b>
      {date}
    </div>
  );
};

Published.displayName = 'Published';

export default Published;
